import { Product } from '@inter-ikea-storageone/range';
import { useSelector } from 'react-redux';
import { getSelectedGroupId, getProductsForGroup, filterApplied } from 'ducks/products';
import { useAppDispatch } from 'ducks/hooks';
import { useEffect, useState } from 'react';
import PlainList from 'ui/PlainList/PlainList';
import ListItem from 'ui/PlainList/ListItem';
import { useIntl } from 'react-intl';
import useIsRtl from 'hooks/useIsRtl';
import Pill from 'ui/Pill/Pill';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import Title, { HeadingType } from 'ui/Typography/Title';

export type Option = {
  id: string;
  name: string;
  filter: (products: Product[]) => Product[];
};

type FilterProps = {
  options: Option[];
};

const TypeFilter = ({ options }: FilterProps) => {
  const dispatch = useAppDispatch();
  const products = useSelector(getProductsForGroup);
  const selectedGroupId = useSelector(getSelectedGroupId);
  const { formatMessage } = useIntl();
  const isRtl = useIsRtl();
  const [selectedType, setSelectedType] = useState<string>('');

  useEffect(() => {
    onSelectType(options[0]);

    return () => {
      dispatch(
        filterApplied({
          id: 'type',
          productGroupId: selectedGroupId,
          productIdList: products.map(p => p.coreProductId),
          filterState: {}
        })
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSelectType = (option: Option) => {
    if (!option || option.id === selectedType) return;
    setSelectedType(option.id);
    const filteredProducts = option.filter(products);
    dispatch(
      filterApplied({
        id: 'type',
        productGroupId: selectedGroupId,
        productIdList: filteredProducts.map(p => p.coreProductId),
        filterState: {}
      })
    );
  };

  return (
    <>
      <Title type={ThemeFontStyleTypeEnum.headingXSmall} heading={HeadingType.HeadingThree}>
        {formatMessage({ id: 'storageone.filterHeader' })}
      </Title>
      <PlainList
        ariaLabelledBy=""
        style={{
          display: 'inline-flex',
          flexWrap: 'wrap',
          listStyleType: 'none',
          margin: '1rem 0',
          padding: 0
        }}
      >
        {options.map(option => (
          <ListItem
            key={option.id}
            style={{ margin: isRtl ? '0 0 0 0.4rem' : '0 0.4rem 0 0', marginBottom: '0.5rem' }}
          >
            <Pill
              label={formatMessage({ id: option.name })}
              onClick={() => onSelectType(option)}
              selected={option.id === selectedType}
            />
          </ListItem>
        ))}
      </PlainList>
    </>
  );
};

export default TypeFilter;
